import React from 'react';
import { Globe, Lightbulb, BookOpen, CheckCircle } from 'lucide-react';

const EnhancedMarkdown = ({ content, className = '' }) => {
  const processContent = (text) => {
    // Étape 1 : Traiter les mots-clés
    let processed = text.replace(
      /\*\*(.*?)\*\*/g,
      '<span class="bg-indigo-50 text-indigo-700 px-1 rounded font-medium">$1</span>'
    );

    // Étape 2 : Traiter les liens spéciaux avec l'icône ExternalLink de Lucide
    processed = processed.replace(
      /\[\[(\d+)\]\]\((.*?)\)/g,
      (match, num, url) => {
        return ` <a href="${url}" 
          target="_blank" 
          rel="noopener noreferrer" 
          class="inline-flex items-center gap-1 px-2 py-1 mx-1 bg-blue-50 text-blue-500 rounded-full text-sm hover:bg-blue-100 transition-colors">
          <span>Source ${num}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
        </a>`;
      }
    );

    // Étape 3 : Traiter les paragraphes
    return processed.split('\n\n').map((paragraph, index) => (
      `<p class="mb-4">${paragraph}</p>`
    )).join('');
  };

  // Créer le HTML sécurisé
  const createMarkup = () => {
    return { __html: processContent(content) };
  };

  return (
    <div 
      className={`prose prose-slate max-w-none ${className}`}
      dangerouslySetInnerHTML={createMarkup()} 
    />
  );
};

export const MarkdownHeading = ({ children, icon: Icon, className = '' }) => {
  const getIconColor = (Icon) => {
    switch (Icon) {
      case Lightbulb:
        return 'text-yellow-500';
      case Globe:
        return 'text-blue-500';
      case CheckCircle:
        return 'text-green-500';
      case BookOpen:
        return 'text-indigo-500';
      default:
        return 'text-blue-500';
    }
  };

  return (
    <div className={`flex items-start gap-3 ${className}`}>
      {Icon && <Icon className={`w-5 h-5 flex-shrink-0 mt-1 ${getIconColor(Icon)}`} />}
      <div className="flex-1">
        {children}
      </div>
    </div>
  );
};

export default EnhancedMarkdown;